import { CardFeaturedItemProps } from '@/modules/components/CardFeaturedItem/CardFeaturedItem';
import {
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import FeatureCards from '@/modules/features/compare/FeatureCards/FeatureCards';
import useGlobalStore from '@/stores/globalStore';
import { StyledFeatureCardsSection } from './FeatureCardsSections.styles';
import { SectionNames } from '@/analytics/sectionNames';

interface FeatureCardsSectionProps {
  title: string;
  sections: {
    title: string;
    cards: CardFeaturedItemProps[];
  }[];
  sectionName?: SectionNames;
}

const FeatureCardsSection = ({
  title,
  sections,
  sectionName,
}: FeatureCardsSectionProps) => {
  const activeSlideIndex = useGlobalStore((state) => state.activeSlideIndex);

  return (
    <StyledFeatureCardsSection>
      <Text tag={TextTag.h3} appearance={TokenTextAppearance.headline300} bold>
        {title}
      </Text>
      {sections.map((section) => (
        <FeatureCards
          key={`${title}${section.title}`}
          title={section.title}
          items={section.cards}
          activeSlideIndex={activeSlideIndex}
          sectionName={sectionName}
        />
      ))}
    </StyledFeatureCardsSection>
  );
};

export default FeatureCardsSection;
